import { Fragment } from "react"
import { Box, makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
    ctaText: { 
        fontFamily: 'poppins',
        fontSize: 32,
        color: theme.palette.common.white,
        marginLeft: 170,
        marginTop: -60,
        [theme.breakpoints.down('sm')]:{
          fontSize: 18,
          marginTop: -35,
          marginLeft: 100
        }
    },
    heroImage: {
        height: 150,
        [theme.breakpoints.down('sm')]:{
            height: 80
        }
    }
}))

export default function Hero({positionClass}) {
    const classes = useStyles()
    return (
        <Fragment>
            <Box className={positionClass}>
                <img src={`${process.env.PUBLIC_URL}/images/nexspec-logo-white.svg`} alt="Nexspec logo" className={classes.heroImage} />
            </Box>
        </Fragment>
    )
}